"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationManufacturerEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const LocationDto_1 = require("../locations/LocationDto");
const LocationEntity_1 = require("../locations/LocationEntity");
const LocationManufacturerDto_1 = require("./LocationManufacturerDto");
const ManufacturerDto_1 = require("../manufacturers/ManufacturerDto");
const ManufacturerEntity_1 = require("../manufacturers/ManufacturerEntity");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class LocationManufacturerEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, locationManufacturer) {
        super();
        this._requiredFieldsSetStatus = {
            locationId: false,
            manufacturerId: false
        };
        this._dependencies = dependencies;
        if (locationManufacturer === undefined) {
            this._dto = new LocationManufacturerDto_1.LocationManufacturerDto();
        }
        else if (locationManufacturer instanceof LocationManufacturerDto_1.LocationManufacturerDto) {
            this._dto = new LocationManufacturerDto_1.LocationManufacturerDto(locationManufacturer);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.locationId);
        }
        else if (locationManufacturer instanceof LocationManufacturerEntity) {
            this._dto = new LocationManufacturerDto_1.LocationManufacturerDto(locationManufacturer._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.locationId);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new LocationManufacturerDto_1.LocationManufacturerDto(this._dto);
    }
    getLocation() {
        if (this._dto.locationId === undefined) {
            return undefined;
        }
        if (this._dto.location === undefined) {
            throw new Error("Cannot call getLocation without first loading the Location.");
        }
        if (!this._locationEntity && this._dto.location) {
            this._locationEntity = new LocationEntity_1.LocationEntity(this._dependencies, this._dto.location);
        }
        return this._locationEntity;
    }
    setLocation(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof LocationDto_1.LocationDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setLocationId(untrustedId);
        if (this.hasError("locationId")) {
            return;
        }
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            this._locationEntity = untrustedValue;
        }
    }
    getLocationId() {
        return this._dto.locationId;
    }
    setLocationId(untrustedValue) {
        let _untrustedValue;
        this.clearError("locationId");
        this._requiredFieldsSetStatus.locationId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location Id is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.locationId) {
            return;
        }
        this._dto.locationId = _untrustedValue;
        delete this._locationEntity;
        this._setIsDirty(true);
    }
    getManufacturer() {
        if (this._dto.manufacturerId === undefined) {
            return undefined;
        }
        if (this._dto.manufacturer === undefined) {
            throw new Error("Cannot call getManufacturer without first loading the Manufacturer.");
        }
        if (!this._manufacturerEntity && this._dto.manufacturer) {
            this._manufacturerEntity = new ManufacturerEntity_1.ManufacturerEntity(this._dependencies, this._dto.manufacturer);
        }
        return this._manufacturerEntity;
    }
    setManufacturer(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof ManufacturerEntity_1.ManufacturerEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof ManufacturerDto_1.ManufacturerDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setManufacturerId(untrustedId);
        if (this.hasError("manufacturerId")) {
            return;
        }
        if (untrustedValue instanceof ManufacturerEntity_1.ManufacturerEntity) {
            this._manufacturerEntity = untrustedValue;
        }
    }
    getManufacturerId() {
        return this._dto.manufacturerId;
    }
    setManufacturerId(untrustedValue) {
        let _untrustedValue;
        this.clearError("manufacturerId");
        this._requiredFieldsSetStatus.manufacturerId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("manufacturerId", "Manufacturer Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("manufacturerId", "Manufacturer Id is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.manufacturerId) {
            return;
        }
        this._dto.manufacturerId = _untrustedValue;
        delete this._manufacturerEntity;
        this._setIsDirty(true);
    }
    loadLocationAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getLocationId()) {
                    return;
                }
                this._emit("before-loadLocationAsync");
                this._dto.location = yield this._dependencies.locationDatastore
                    .getAsync(this.getLocationId(), expand);
                delete this._locationEntity;
                this._emit("after-loadLocationAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadManufacturerAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getManufacturerId()) {
                    return;
                }
                this._emit("before-loadManufacturerAsync");
                this._dto.manufacturer = yield this._dependencies.manufacturerDatastore
                    .getAsync(this.getManufacturerId(), expand);
                delete this._manufacturerEntity;
                this._emit("after-loadManufacturerAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.locationManufacturerDatastore
                    .getAsync(id, expand);
                delete this._locationEntity;
                delete this._manufacturerEntity;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Location Manufacture is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.locationManufacturerDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.locationManufacturerDatastore
                        .updateAsync(this._dto);
                }
                this._dto.locationId = dto.locationId;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Location Manufacture cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.locationManufacturerDatastore
                        .removeAsync(this.getLocationId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.LocationManufacturerEntity = LocationManufacturerEntity;
//# sourceMappingURL=LocationManufacturerEntity.js.map